
import React, {useCallback, useEffect, useState} from 'react';
// removed unused useNavigate import
import {DropDownListComponent} from '../../components/DropDownListComponent';
import { data } from '../Calendar/data';
import {Loading} from '../../components';
import * as C from './components';
import {
  dropdownData,
} from './styles';
import {useStateContext} from '../../contexts/ContextProvider';
import {Colors} from "../../styles";
import {ComboStore} from "../../stores/combo/comboStore";
import {Manager} from "../../core";
import {CustomerStore} from "../../stores/customers/customersStore";
import {SchedulesStore} from "../../stores/schedules/schedulesStore";

//TODO: use to select users
export const DropDown = (currentMode: any) => {
  return (
    <div className="w-28 border-1 border-color px-2 py-1 rounded-md">
      <DropDownListComponent id="time" fields={{text: 'Time', value: 'Id'}}
                             style={{border: 'none', color: `${(currentMode === 'Dark') && 'white'}`}} value="1"
                             dataSource={dropdownData} popupHeight="220px" popupWidth="120px"/>
    </div>
  );
};

export const Home = () => {
  useStateContext();
  ComboStore();
  const [loading, setLoading] = useState(false);
  const [, setScheduleObj] = useState();
  const [schedules, setSchedules] = useState(data);

  const handlerSchedulesRequest = useCallback(async () => {
    try {
      const response =  await SchedulesStore().get();
      const list = response.filter(e => e.Status !== 'CANCELED');
      setSchedules(list);
    } catch (e) {
      Manager.RequestError('error.calendar.handlerRequest', e);
    }
  }, []);

  useEffect( () => {
    setLoading(true)
    Promise.all([
      handlerSchedulesRequest(),
      ComboStore().get(),
      CustomerStore().get(),
      ComboStore().get(),
    ]).catch((err) => {
      Manager.RequestError('error.dashboard.promise', err);
    }).finally(() => {
      setLoading(false);
    })
  }, [handlerSchedulesRequest]);


  return loading ? (
    <div style={{position: 'absolute', width: '100%', height: '100%'}}>
      <Loading backgroundColor={Colors.light} type={'bubbles'} color={Colors.green_darker} />
    </div>
  ) : (
    <div className="mt-24">
      <div className="flex flex-wrap lg:flex-nowrap justify-center ">
        <C.MonthAmount />
        <C.Statistics />
      </div>
      <div className="flex flex-wrap lg:flex-wrap justify-center ">
        <C.GenericNotifications />
        <C.AlertNotifications />
      </div>
      <div className="flex flex-wrap lg:flex-nowrap justify-center ">
        <C.DiscountConfig />
        <C.AvailabilityConfig />
      </div>
      <C.NextSchedules schedules={schedules} callback={(date: React.SetStateAction<undefined>) => setScheduleObj(date)} />
    </div>
  );
};
